import React from "react";
import { parseMinutesLong } from "~/lib/localize.js";

export const FlightMotorTime = ({ motorMinutes }) => {
  if (!motorMinutes || motorMinutes <= 0) {
    return null;
  }

  return (
    <span>
      <span className="bold">M</span>{" "}
      {parseMinutesLong(motorMinutes)}
    </span>
  );
};
